export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishedAt: string;
  updatedAt: string;
  imageSeq: string;
  imagePrompt: string;
  tags: string[];
  readTime: number;
}

export const categories = [
  { slug: 'guide', name: '功能指南', description: '详细介绍 91.cc 平台的各项功能与使用方法' },
  { slug: 'news', name: '最新动态', description: '91.cc 平台最新资讯、更新公告与行业动态' },
  { slug: 'faq', name: '常见问题', description: '关于 91.cc 访问、注册、使用的常见问题解答' },
  { slug: 'security', name: '安全访问', description: '如何安全、稳定地访问 91.cc 平台' },
];

export const articles: Article[] = [
  {
    slug: 'official-entry-guide',
    title: '91.cc 官方入口完整指南 — 安全访问 91.cc 的三种方式',
    excerpt: '本文详细介绍访问 91.cc 官方平台的三种安全方式，包括直接访问、备用入口和客户端方式，帮助用户随时随地稳定连接 91.cc 平台。',
    content: `<p>91.cc 作为备受用户关注的网络平台，每天有大量用户通过各种方式访问。本文将详细介绍访问 91.cc 官方平台的三种安全方式，帮助您稳定、快速地连接到平台。</p>
<h2>方式一：直接访问官方网站</h2>
<p>最直接的方式是通过浏览器输入 91.cc 官方网址进行访问。建议将官方网址添加到浏览器收藏夹，方便日常快速访问。为确保访问安全，请务必确认您访问的是 91.cc 官方网站，避免进入仿冒网站。</p>
<p>访问前请确保您的网络环境稳定，建议使用主流浏览器如 Chrome、Firefox 或 Edge 的最新版本，以获得最佳的访问体验。</p>
<h2>方式二：备用入口访问</h2>
<p>当主入口因网络波动或其他原因无法访问时，91.cc 提供了备用入口通道。这些备用入口同样由官方维护，安全可靠。建议用户关注 91.cc 官方公告渠道，获取最新的备用入口信息。</p>
<p>使用备用入口时，请注意核实入口地址的真实性，避免使用来源不明的第三方链接。</p>
<h2>方式三：客户端方式访问</h2>
<p>91.cc 官方客户端提供了更稳定的访问体验。下载安装官方客户端后，即使网络环境发生变化，也能通过客户端内置的智能路由功能保持连接稳定。</p>
<p>官方客户端还提供了消息推送、快捷操作等额外功能，全面提升使用体验。</p>
<h2>安全访问注意事项</h2>
<ul>
<li>始终从官方渠道获取访问地址和客户端下载链接</li>
<li>不要轻信社交媒体或论坛中传播的非官方入口链接</li>
<li>定期更新浏览器和客户端到最新版本</li>
<li>使用安全的网络环境访问，避免使用公共 Wi-Fi</li>
<li>如遇访问异常，请通过官方客服渠道反馈</li>
</ul>`,
    category: 'guide',
    author: '91.cc 信息中心',
    publishedAt: '2026-07-28',
    updatedAt: '2026-08-05',
    imageSeq: 'article-entry-guide',
    imagePrompt: 'A modern clean digital illustration of a secure web browser window showing a platform portal entrance with a glowing entry gate symbol, warm orange and teal accent colors, minimalist flat design style, soft gradient background in light cream tones, abstract geometric shapes representing connectivity and security, no text or logos visible, professional and trustworthy atmosphere, high quality digital art with smooth gradients',
    tags: ['官方入口', '安全访问', '使用指南'],
    readTime: 5,
  },
  {
    slug: 'registration-tutorial',
    title: '91.cc 新用户注册与认证完整教程',
    excerpt: '从零开始，手把手教你完成 91.cc 平台的新用户注册、实名认证和账户安全设置，让您快速开启 91.cc 之旅。',
    content: `<p>欢迎来到 91.cc！本教程将手把手教您完成新用户注册、认证和账户设置，让您快速上手使用 91.cc 平台的全部功能。</p>
<h2>第一步：访问注册页面</h2>
<p>打开 91.cc 官方网站，在首页右上角点击"注册"按钮，即可进入注册页面。您也可以直接在浏览器地址栏输入注册页面地址进行访问。</p>
<h2>第二步：填写基本信息</h2>
<p>按照页面提示填写您的用户名、密码和邮箱地址。请注意：</p>
<ul>
<li>用户名长度应为 4-20 个字符，支持字母、数字和下划线</li>
<li>密码需包含大小写字母和数字，长度不少于 8 位</li>
<li>请使用有效的邮箱地址，后续将用于账户验证和找回密码</li>
</ul>
<h2>第三步：邮箱验证</h2>
<p>提交注册信息后，系统会向您填写的邮箱发送一封验证邮件。请在 30 分钟内点击邮件中的验证链接完成邮箱验证。</p>
<h2>第四步：完善个人资料</h2>
<p>邮箱验证通过后，登录账户并进入个人中心，完善您的个人资料。建议上传真实头像并填写个人简介，这有助于提升账户的可信度。</p>
<h2>第五步：安全设置</h2>
<p>为保障账户安全，建议您进行以下安全设置：绑定手机号码、设置密保问题和答案、开启登录保护功能。</p>`,
    category: 'guide',
    author: '91.cc 信息中心',
    publishedAt: '2026-07-25',
    updatedAt: '2026-08-03',
    imageSeq: 'article-registration',
    imagePrompt: 'A clean and modern digital illustration of a user registration interface on a laptop screen, showing a friendly signup form with soft warm lighting, minimalist design with orange and cream tones, welcoming atmosphere, abstract user avatar icon floating above the screen, modern workspace setting with plants and warm ambient light, professional yet approachable digital art style, smooth gradients and soft shadows',
    tags: ['新用户', '注册教程', '账户安全'],
    readTime: 6,
  },
  {
    slug: 'platform-features',
    title: '91.cc 核心功能全面介绍 — 一站式平台服务详解',
    excerpt: '全面解析 91.cc 平台的核心功能模块，包括内容浏览、社区互动、个人中心、增值服务等，帮助您充分挖掘平台价值。',
    content: `<p>91.cc 平台集成了丰富的功能模块，为用户提供一站式的网络服务体验。本文将全面介绍 91.cc 的核心功能，帮助您充分了解和使用平台的各项服务。</p>
<h2>内容浏览功能</h2>
<p>91.cc 平台提供海量的优质内容，涵盖多个领域和类别。用户可以通过分类浏览、关键词搜索、热门推荐等多种方式发现感兴趣的内容。平台采用智能推荐算法，根据用户的浏览偏好推送个性化内容。</p>
<h2>社区互动功能</h2>
<p>平台内置完善的社区互动系统，用户可以进行评论交流、点赞收藏、关注其他用户等操作。社区氛围友好活跃，用户可以在这里找到志同道合的朋友，分享经验和见解。</p>
<h2>个人中心功能</h2>
<p>每位用户都拥有专属的个人中心，可以管理个人资料、查看浏览历史、收藏夹和订阅内容。个人中心还提供了数据统计功能，帮助用户了解自己的使用习惯和偏好。</p>
<h2>增值服务功能</h2>
<p>91.cc 为注册用户提供了多项增值服务，包括优先体验新功能、专属客服通道、高级内容推荐等。平台定期推出各种活动和福利回馈用户。</p>
<h2>安全保障功能</h2>
<p>平台采用多重安全防护措施，包括数据加密传输、账户安全保护、隐私设置管理等，全方位保障用户的信息安全和隐私权益。</p>`,
    category: 'guide',
    author: '91.cc 信息中心',
    publishedAt: '2026-07-20',
    updatedAt: '2026-08-01',
    imageSeq: 'article-features',
    imagePrompt: 'A modern digital illustration showcasing multiple service platform features as interconnected floating cards with icons, warm orange and teal color palette, minimalist flat design, light cream background with subtle geometric patterns, each card representing a different service module, clean and organized composition, professional tech atmosphere, smooth gradients and soft ambient lighting',
    tags: ['功能介绍', '平台服务', '核心模块'],
    readTime: 7,
  },
  {
    slug: 'security-tips',
    title: '91.cc 安全访问与账户保护最佳实践',
    excerpt: '为您总结 91.cc 平台安全访问的五大要点，包括密码管理、网络环境、防钓鱼技巧等，全方位守护您的账户安全。',
    content: `<p>网络安全是每位用户都应重视的问题。本文将为您总结 91.cc 平台安全访问和账户保护的五大要点，帮助您安全无忧地使用平台。</p>
<h2>一、强密码管理</h2>
<p>为您的 91.cc 账户设置一个强密码是安全的第一道防线。建议密码长度不少于 12 位，包含大小写字母、数字和特殊字符的组合。避免使用生日、手机号等容易被猜测的信息作为密码。不同平台使用不同的密码，定期更换密码。</p>
<h2>二、安全的网络环境</h2>
<p>访问 91.cc 时，请尽量使用私有的、受信任的网络环境。避免在公共 Wi-Fi 下登录账户或进行敏感操作。如果必须使用公共网络，建议开启 VPN 加密连接。</p>
<h2>三、防范钓鱼攻击</h2>
<p>警惕仿冒 91.cc 的钓鱼网站和虚假邮件。请始终通过官方渠道访问平台，不要点击来源不明的链接。91.cc 官方不会通过邮件或私信索要您的密码和验证码。</p>
<h2>四、开启双重验证</h2>
<p>91.cc 平台支持双重验证功能，建议您在账户安全设置中开启。开启后，每次登录除了输入密码外，还需要输入动态验证码，大大提高了账户的安全性。</p>
<h2>五、定期安全检查</h2>
<p>养成定期检查账户安全状态的习惯。查看最近的登录记录，确认没有异常登录。及时更新绑定的手机号和邮箱，确保账户恢复渠道畅通。</p>`,
    category: 'security',
    author: '91.cc 安全团队',
    publishedAt: '2026-07-18',
    updatedAt: '2026-08-04',
    imageSeq: 'article-security',
    imagePrompt: 'A modern cybersecurity themed digital illustration showing a shield icon protecting digital assets, warm dark background with orange and teal accent lighting, minimalist flat design style, abstract network nodes and security lock symbols, clean professional composition, conveying trust and protection, high quality digital art with geometric security patterns, smooth gradients',
    tags: ['安全访问', '账户保护', '防钓鱼'],
    readTime: 5,
  },
  {
    slug: 'latest-update-2026',
    title: '91.cc 2026年8月最新更新公告 — 多项功能优化上线',
    excerpt: '91.cc 平台于 2026年8月进行了重要更新，包括界面优化、性能提升和新功能上线，全面改善用户体验。',
    content: `<p>91.cc 平台始终致力于为用户提供更好的服务体验。2026年8月，平台进行了多项重要更新，本文将为您详细介绍本次更新的主要内容。</p>
<h2>界面全面升级</h2>
<p>本次更新对平台整体界面进行了重新设计，采用了更加简洁现代的设计风格。导航结构更加清晰，页面加载速度显著提升，操作流程更加顺畅。新界面适配了各种屏幕尺寸，在移动端的体验也得到了大幅改善。</p>
<h2>性能大幅提升</h2>
<p>技术团队对底层架构进行了深度优化，页面平均加载速度提升了 40%，内容刷新更加实时流畅。服务器稳定性进一步增强，即使在高并发场景下也能保持良好表现。</p>
<h2>新功能上线</h2>
<p>本次更新推出了多项用户期待已久的新功能，包括智能内容推荐、夜间模式、批量操作工具等。这些功能的上线将进一步提升用户的使用效率和舒适度。</p>
<h2>安全体系强化</h2>
<p>安全方面，平台升级了加密协议，增加了异常登录检测和实时预警机制。用户可以更加安心地在平台上进行各项操作。</p>`,
    category: 'news',
    author: '91.cc 信息中心',
    publishedAt: '2026-08-01',
    updatedAt: '2026-08-05',
    imageSeq: 'article-update',
    imagePrompt: 'A modern digital illustration showing a platform update announcement with glowing notification cards, warm orange and cream color palette, minimalist flat design, abstract upgrade symbols and progress indicators, clean organized layout, professional tech atmosphere with soft ambient lighting, smooth geometric shapes representing innovation and improvement',
    tags: ['最新更新', '功能优化', '版本公告'],
    readTime: 4,
  },
  {
    slug: 'faq-account-issues',
    title: '91.cc 账户相关问题解答汇总',
    excerpt: '汇总整理 91.cc 用户最常遇到的账户相关问题，包括无法登录、密码找回、账户安全等，提供详细的解决方案。',
    content: `<p>在日常使用 91.cc 的过程中，用户可能会遇到各种账户相关的问题。本文汇总了最常见的账户问题及其解决方案，希望能帮助您快速解决问题。</p>
<h2>问题一：忘记密码怎么办？</h2>
<p>在登录页面点击"忘记密码"，按照提示输入注册时使用的邮箱地址。系统会发送一封密码重置邮件到您的邮箱，点击邮件中的链接即可设置新密码。如果收不到邮件，请检查垃圾邮件箱。</p>
<h2>问题二：账户被锁定如何处理？</h2>
<p>连续多次输入错误密码会导致账户临时锁定。通常情况下，等待 30 分钟后会自动解锁。如果急需使用，可以联系官方客服进行人工解锁。</p>
<h2>问题三：如何修改绑定邮箱？</h2>
<p>登录账户后，进入个人中心的"安全设置"页面，选择"修改绑定邮箱"。系统会向当前绑定邮箱发送验证码，验证通过后即可输入新的邮箱地址进行绑定。</p>
<h2>问题四：账户被盗用怎么办？</h2>
<p>如果发现账户有异常登录或操作，请立即修改密码并联系官方客服。平台会对被盗账户进行临时冻结处理，防止进一步损失。建议开启双重验证功能以增强账户安全性。</p>`,
    category: 'faq',
    author: '91.cc 客服团队',
    publishedAt: '2026-07-15',
    updatedAt: '2026-08-02',
    imageSeq: 'article-faq-account',
    imagePrompt: 'A modern customer support illustration with a friendly help desk scene, warm orange and cream tones, minimalist flat design, question mark icons floating above a glowing knowledge base, clean organized composition, helpful and approachable atmosphere, abstract communication symbols, professional digital art style with soft gradients',
    tags: ['常见问题', '账户管理', '密码找回'],
    readTime: 5,
  },
  {
    slug: 'platform-comparison',
    title: '91.cc 与其他同类平台的功能对比分析',
    excerpt: '从功能、安全性、用户体验、社区活跃度等多个维度，客观对比 91.cc 与同类平台的差异，帮助用户做出明智选择。',
    content: `<p>在众多网络平台中，91.cc 凭借其独特的功能和优质的服务脱颖而出。本文将从多个维度对 91.cc 与同类平台进行客观对比分析。</p>
<h2>功能丰富度对比</h2>
<p>91.cc 提供了全面的功能体系，涵盖内容浏览、社区互动、个性化推荐、数据统计等多个方面。相比同类平台，91.cc 的功能整合度更高，用户无需在多个应用之间切换即可完成各种操作。</p>
<h2>安全性对比</h2>
<p>在安全方面，91.cc 采用了业界领先的加密技术和安全防护措施。多重验证机制、异常登录检测、数据加密传输等功能为用户的账户安全提供了全方位保障。</p>
<h2>用户体验对比</h2>
<p>91.cc 注重用户体验的每一个细节。从简洁直观的界面设计到流畅的操作流程，再到智能化的内容推荐，91.cc 在用户体验方面持续优化，获得了用户的广泛好评。</p>
<h2>社区活跃度对比</h2>
<p>91.cc 拥有活跃友好的用户社区，用户之间的互动频繁且质量较高。平台定期举办社区活动，增强用户粘性和归属感。</p>`,
    category: 'guide',
    author: '91.cc 信息中心',
    publishedAt: '2026-07-10',
    updatedAt: '2026-07-28',
    imageSeq: 'article-comparison',
    imagePrompt: 'A modern comparison chart illustration showing multiple platform feature cards side by side, warm orange and teal color palette, minimalist flat design, clean bar chart and comparison graphics, light cream background with subtle data visualization elements, professional analytical atmosphere, smooth geometric shapes, organized and balanced composition',
    tags: ['平台对比', '功能分析', '选型参考'],
    readTime: 6,
  },
  {
    slug: 'mobile-app-guide',
    title: '91.cc 移动客户端使用完全指南',
    excerpt: '详细介绍 91.cc 移动客户端的下载、安装、配置和使用方法，让您随时随地享受 91.cc 的完整服务。',
    content: `<p>91.cc 移动客户端为用户提供了随时随地的便捷访问体验。本指南将详细介绍移动客户端的下载、安装和使用方法。</p>
<h2>客户端下载</h2>
<p>您可以通过 91.cc 官方网站的下载页面获取最新版本的移动客户端。平台同时提供 iOS 和 Android 版本，请根据您的设备选择对应的版本下载。</p>
<h2>安装与配置</h2>
<p>下载完成后，按照系统提示完成安装。首次启动客户端时，建议允许必要权限以确保功能的正常使用。登录您的 91.cc 账户即可同步所有数据。</p>
<h2>客户端特色功能</h2>
<p>移动客户端除支持网页版的所有功能外，还提供了以下特色功能：消息推送通知、离线内容缓存、手势快捷操作、夜间阅读模式、流量节省模式。</p>
<h2>常见问题</h2>
<p>如遇客户端闪退、加载缓慢等问题，建议尝试清除缓存或重新安装最新版本。持续性问题可联系官方客服获取技术支持。</p>`,
    category: 'guide',
    author: '91.cc 信息中心',
    publishedAt: '2026-07-05',
    updatedAt: '2026-07-25',
    imageSeq: 'article-mobile',
    imagePrompt: 'A modern digital illustration of a smartphone displaying a clean mobile app interface with warm orange accents, minimalist flat design, handheld device on a clean desk setup, soft cream background with subtle shadows, modern tech lifestyle aesthetic, smooth gradients and friendly approachable atmosphere, high quality mobile app presentation style',
    tags: ['移动客户端', '使用指南', 'App教程'],
    readTime: 5,
  },
  {
    slug: 'community-guidelines',
    title: '91.cc 社区行为规范与使用准则',
    excerpt: '了解 91.cc 平台的社区行为规范，包括发言准则、内容发布标准、违规处理机制等，共同维护良好的社区环境。',
    content: `<p>为维护 91.cc 平台良好的社区环境，保障每位用户的合法权益，平台制定了社区行为规范与使用准则。请所有用户仔细阅读并遵守以下规定。</p>
<h2>基本行为准则</h2>
<p>尊重他人是社区交流的基础。请使用文明用语，不得发布人身攻击、侮辱谩骂、歧视性言论。尊重知识产权，转载内容需注明出处。保护个人隐私，不得公开他人隐私信息。</p>
<h2>内容发布标准</h2>
<p>发布内容应符合国家法律法规和社会主义核心价值观。禁止发布违法违规、虚假诈骗、暴力恐怖、色情低俗等内容。鼓励发布原创、有价值、积极向上的内容。</p>
<h2>违规处理机制</h2>
<p>平台建立了完善的违规处理机制。对于违规行为，将根据情节轻重采取警告、限制功能、临时封禁、永久封禁等措施。用户如对处理结果有异议，可以通过申诉渠道进行反馈。</p>`,
    category: 'guide',
    author: '91.cc 管理团队',
    publishedAt: '2026-06-28',
    updatedAt: '2026-07-20',
    imageSeq: 'article-community',
    imagePrompt: 'A modern illustration representing online community guidelines and respectful communication, warm orange and cream color palette, minimalist flat design, interconnected user avatars forming a harmonious circle, light background with subtle community symbols, friendly inclusive atmosphere, abstract communication patterns, professional digital art with smooth gradients',
    tags: ['社区规范', '行为准则', '用户守则'],
    readTime: 4,
  },
  {
    slug: 'faq-access-issues',
    title: '91.cc 访问异常问题排查指南',
    excerpt: '当您遇到 91.cc 无法访问、加载缓慢等问题时，可以参考本指南进行排查解决，涵盖网络、浏览器、DNS 等方面。',
    content: `<p>访问 91.cc 时偶尔会遇到连接异常的情况。本文将为您提供系统化的排查方法，帮助您快速解决访问问题。</p>
<h2>检查网络连接</h2>
<p>首先确认您的网络连接是否正常。尝试访问其他网站，如果都无法打开，说明是您的网络存在问题。可以尝试重启路由器或切换网络环境。</p>
<h2>清除浏览器缓存</h2>
<p>浏览器缓存可能导致页面加载异常。尝试清除浏览器缓存和 Cookie，然后重新访问 91.cc。您可以在浏览器设置的"隐私与安全"选项中找到清除缓存的选项。</p>
<h2>更换 DNS 服务器</h2>
<p>DNS 解析问题也可能导致无法访问。建议将 DNS 服务器更换为公共 DNS，如 114.114.114.114 或 8.8.8.8。修改 DNS 后需要刷新 DNS 缓存。</p>
<h2>检查防火墙设置</h2>
<p>某些防火墙或安全软件可能误拦截 91.cc 的访问。尝试暂时关闭防火墙或安全软件，确认是否能够正常访问。如果可以，将 91.cc 添加到信任列表中。</p>
<h2>使用备用入口</h2>
<p>如果以上方法均无效，可以尝试使用 91.cc 提供的备用入口进行访问。关注官方公告获取最新的备用入口信息。</p>`,
    category: 'faq',
    author: '91.cc 技术团队',
    publishedAt: '2026-06-20',
    updatedAt: '2026-07-30',
    imageSeq: 'article-access-faq',
    imagePrompt: 'A modern technical troubleshooting illustration showing network diagnostics with glowing connection nodes, warm orange and cream tones, minimalist flat design, abstract network topology with diagnostic symbols, clean organized layout, helpful problem-solving atmosphere, professional IT support aesthetic, smooth geometric shapes and connection lines',
    tags: ['访问异常', '问题排查', '技术指南'],
    readTime: 6,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getLatestArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, count);
};

export const getRelatedArticles = (currentSlug: string, count: number = 3): Article[] => {
  const current = articles.find((a) => a.slug === currentSlug);
  if (!current) return [];
  return articles.filter((a) => a.slug !== currentSlug && a.category === current.category).slice(0, count);
};